<template>
    <CButton
        :block="block"
        :color="color"
        :disabled="disabled"
        :type="type"
        :title="title"
        class="button shadow d-flex create-button"
        @click="$emit('click')"
    >
        <span class="button__icon">
            <CIcon :content="$options.icons.cilPlus"/>
        </span>
        <span class="button__text">
            <slot>
                {{ $t("create") }}
            </slot>
            
        </span>
    </CButton>
</template>

<script>
import { cilPlus } from '@coreui/icons';
export default {
    name: "ButtonCreate",
    icons:{
        cilPlus
    },
    props: {
        block: {
            type: Boolean,
            default: false
        },
        color: String,
        disabled: Boolean,
        type: String,
        title: String
    }

}
</script>
<style lang="scss">

</style>